import { useEffect, useState } from 'react'
import { useComputed } from '@preact/signals-react'

import AddRolesBusinessEntityLeaves from './AddRolesBusinessEntityLeaves.jsx'
import Icon from '../../../components/Icon.jsx'
import LoadingAnimation from '../../../components/LoadingAnimation.jsx'
import SetMembershipCheckbox from '../../../components/SetMembershipCheckbox.jsx'

import { organizationRoleListLoadedSignal, organizationRoleListErrorSignal, organizationRoleDictionarySignal } from '../../../state/signals/roleSignals.js'

import { BusinessEntityType, OrganizationType, RoleMasks } from '../../../utils/constants'
import { iconForOrgType } from '../../../utils/utils'

const AddRolesBusinessEntityLeaf = ({ childOrg, selectedRoleIdSignal, selectedOrganizationsSignal, enableAddRoleSignal, depth=0}) => {

	const selectedRoleComputed = useComputed(
		() => {
			if (!selectedRoleIdSignal.value || !organizationRoleListLoadedSignal.value || !organizationRoleDictionarySignal.value) {
				return null
			}
			const roleId = selectedRoleIdSignal.value
			if (!(roleId in organizationRoleDictionarySignal.value)) {
				throw Error(`Organization role dictionary does not include a role with ID ${roleId}`)
			}
			return organizationRoleDictionarySignal.value[roleId]
		}
	)

	const isUniversalRole = function (role) {
		return role.businessEntityRoleMask & RoleMasks.Universal
	}

	const isMerchantRole = function (role) {
		return isUniversalRole(role) || role.businessEntityRoleMask & RoleMasks.Merchant
	}

	const isOrganizationRole = function (role) {
		return isUniversalRole(role) || role.businessEntityRoleMask & RoleMasks.Organization
	}

	const isResellerRole = function (role) {
		return isUniversalRole(role) || role.businessEntityRoleMask & RoleMasks.Reseller
	}

	const isRootRole = function (role) {
		return isUniversalRole(role) || role.businessEntityRoleMask & RoleMasks.Root
	}

	const matchBusinessEntityAndRoleTypes = (childOrg, selectedRole) => {
		if (!childOrg) {
			return false
		}
		if (!("businessEntityTypeId" in childOrg)) {
			return false
		}
		switch (childOrg.businessEntityTypeId) {
			case BusinessEntityType.Organization:
				if (!("businessEntitySubTypeId" in childOrg)) {
					return false
				}
				switch (childOrg.businessEntitySubTypeId) {
					case OrganizationType.Root:
						return isRootRole(selectedRole)
					case OrganizationType.Reseller:
						return isResellerRole(selectedRole)
					case OrganizationType.Standard:
						return isOrganizationRole(selectedRole)
					default:
						return false
				}
			case BusinessEntityType.Merchant:
				return isMerchantRole(selectedRole)
			default:
				return false
		}
	}

	if (!organizationRoleListLoadedSignal.value) {
		return <LoadingAnimation />
	}
	if (!selectedRoleIdSignal.value) {
		console.error("SelectedRoleComputed does not have a value")
		return <></>
	}

	return (<>{
		(
			matchBusinessEntityAndRoleTypes(childOrg, selectedRoleComputed.value)
		) && (<>
			<tr key={childOrg.id}>
				<td style={{ paddingLeft: (depth * 30).toString().concat('px') }}>
					<Icon icon={iconForOrgType(childOrg)} height={16} width={16} />&nbsp;
					{childOrg.name}
				</td>
				<td className='checkbox-container'>
					<SetMembershipCheckbox
						id={childOrg.id}
						checkboxId={`AddGroupRoleCheck:${selectedRoleIdSignal.value}:${childOrg.id}`}
						selectedEntitySetSignal={selectedOrganizationsSignal}
						enableSubmitSignal={enableAddRoleSignal}
					/>
				</td>
			</tr>
			<AddRolesBusinessEntityLeaves 
				companies={childOrg.companies}
				selectedRoleIdSignal={selectedRoleIdSignal}
				selectedOrganizationsSignal={selectedOrganizationsSignal}
				depth={depth + 1}
				enableAddRoleSignal={enableAddRoleSignal}
			></AddRolesBusinessEntityLeaves>
		</>)
	}</>)
}
export default AddRolesBusinessEntityLeaf